import { render, staticRenderFns } from "./order-products.vue?vue&type=template&id=686d877a&scoped=true&"
import script from "./order-products.vue?vue&type=script&lang=js&"
export * from "./order-products.vue?vue&type=script&lang=js&"
import style0 from "./order-products.vue?vue&type=style&index=0&id=686d877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d877a",
  null
  
)

export default component.exports